export default {
  'home.title': 'ホーム',
  'home.event': 'イベント',
  'home.news': 'お知らせ',
  'home.event_information': 'イベント情報',
  'home.announcement': 'お知らせ情報',
  'home.goto': '移動',
  'home.latest_events': '最新イベント',
  'home.more_events': 'さらに多くのイベント',
  'home.empty': '現在、コンテンツはありません',
} as Record<string, string>;
